import { action, observable, makeObservable } from 'mobx';
import { ReturnAddressForm } from 'modules/return-address/forms';
import { ApplicationStore } from 'platform/application/stores';
import { BaseViewStore } from 'core/stores';
import { notificationError, isSome, isSuperAdminOrganization } from 'core/utils';
import { LookupStore } from 'modules/lookup/stores';
import { ReturnAddressStore } from 'modules/return-address/stores';
import { AddressAutofillViewStore, BaasicDropdownViewStore } from 'common/stores';
import { lookupRouteName, sourceOfChange } from 'common/constants';
import _ from 'lodash';

class ReturnAddressEditViewStore extends BaseViewStore {
	isUpdateAction = isSome(this.rootStore.routerStore.routerState.params.id);
	organizationTypeId = null;
	@observable stateOptions = [];
	@observable tempStateOptions = [];
	@observable pageState = 1;
	@observable countryOptions = [];
	@observable tempCountryOptions = [];
	@observable pageCountry = 1;
	@observable infiniteSearchPhrase = null;
	debouncedStateSearch = null;
	debouncedCountrySearch = null;
	returnAddress;
	isEdit = false;
	isSuperAdmin = false;
	@observable isStateLoading = false;
	@observable isCountryLoading = false;

	form = new ReturnAddressForm({
		onSuccess: async () => {
			await this.createOrUpdateReturnAddress();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.listStore = new ReturnAddressStore(rootStore);
		this.lookupStore = new LookupStore(rootStore);
		this.isEdit = this.modalParams.data.isEdit;
		this.isSuperAdmin = isSuperAdminOrganization(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		this.stateDropdownStore = new BaasicDropdownViewStore({
			lookupRoute: lookupRouteName.state,
			field: this.form.$('coreCountryStateId'),
			store: this.lookupStore,
		});
		this.countryDropdownStore = new BaasicDropdownViewStore({
			lookupRoute: lookupRouteName.country,
			field: this.form.$('coreCountryId'),
			store: this.lookupStore,
		});
		this.addressAutofillViewStore = new AddressAutofillViewStore(this.rootStore, {
			parentViewData: {
				address1: this.form.$('address.address1'),
				address2: this.form.$('address.address2'),
				city: this.form.$('address.city'),
				zipCode: this.form.$('address.zipCode'),
				isBaasicDropdown: true,
				stateDropdownStore: this.stateDropdownStore,
				countryDropdownStore: this.countryDropdownStore,
			},
		});
		if (this.isSuperAdmin) {
			this.sellerDropdownStore = new BaasicDropdownViewStore({
				localStorageHandlerKey: 'selectedSeller',
				field: this.form.$('sellerId'),
				store: new ApplicationStore(this.rootStore),
				itemTemplate: {
					value: 'id',
					label: 'applicationTitle',
				},
				filterProperties: {
					sellerOnly: true,
				},
			});
			this.form.$('sellerId').set('rules', 'required');
		}
		if (this.isEdit) {
			this.returnAddress = this.modalParams.data.selectedItem;
			this.form.updateForm(this.returnAddress, false);
			this.countryDropdownStore.setValue({
				value: this.returnAddress.address.coreCountryId,
				label: this.returnAddress.address.coreCountry.name,
				extra: this.returnAddress.address.coreCountry,
			});
			this.stateDropdownStore.setValue({
				value: this.returnAddress.address.coreCountryStateId,
				label: this.returnAddress.address.coreCountryState.name,
				extra: this.returnAddress.address.coreCountryState,
			});
		}
		this.resume();
	};

	@action.bound createOrUpdateReturnAddress = async () => {
		this.suspend();
		const { name, address, coreCountryId, coreCountryStateId, isDefaultReturnAddress, sellerId } = this.form.values();
		try {
			const baseObj = {
				id: this.returnAddress != null ? this.returnAddress.addressId : '',
				...address,
				coreCountryStateId,
				coreCountryId,
			};
			if (this.isEdit) {
				const returnAddressForUpdate = {
					id: this.returnAddress.id,
					name: name,
					addressId: this.returnAddress.addressId,
					address: baseObj,
					sellerId: this.returnAddress.sellerId,
					isDefaultReturnAddress: isDefaultReturnAddress,
					isWarehouse: false,
					fullAddress: '',
				};
				await this.listStore.updateReturnAddress(returnAddressForUpdate, sourceOfChange.updateReturnAddress);
				this.rootStore.notificationStore.success(['RETURNADDRESSVIEW.EDITSUCCESS', { name: name }]);
			} else {
				const returnAddressForCreate = {
					name: name,
					address: baseObj,
					sellerId: this.isSuperAdmin ? sellerId : null,
					isDefaultReturnAddress: isDefaultReturnAddress,
					isWarehouse: false,
					fullAddress: '',
				};
				await this.listStore.createReturnAddress(returnAddressForCreate, sourceOfChange.createReturnAddress);
				this.rootStore.notificationStore.success(['RETURNADDRESSVIEW.CREATESUCCESS', { name: name }]);
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};
}

export default ReturnAddressEditViewStore;



// WEBPACK FOOTER //
// ./src/modules/return-address/stores/ReturnAddressEditViewStore.js